<template>
  <main id='subPage' class='admin'>
    <!-- 카테고리 -->
    <section id='category'>
      <h2>관리자 메뉴</h2>
      <ul class='breadCrumb'>
        <li class='home'></li>
        <li class='web'>
          <p class='pageTxt'>관리자 메뉴</p>
          <ul class='depth'>
            <li>
              <router-link to='/generalmembership' title='관리자 메뉴'>관리자 메뉴</router-link>
            </li>
            <li>
              <router-link to='/usermanagement' title='시스템 관리'>시스템 관리</router-link>
            </li>
          </ul>
        </li>
        <li class='web'>
          <p class='pageTxt'>팝업/배너관리</p>
          <ul class='depth'>
            <li>
              <router-link to='/generalmembership' title='회원관리'>회원관리</router-link>
            </li>
            <li>
              <router-link to='/discountvehicle' title='할인차량관리'>할인차량관리</router-link>
            </li>
            <li>
              <router-link to='/periodparking' title='정기권 주차장관리'>정기권 주차장관리</router-link>
            </li>
            <li>
              <router-link to='/noticemanagement' title='게시판관리'>게시판관리</router-link>
            </li>
            <li>
              <router-link to='/popuplist' title='팝업/배너관리'>팝업/배너관리</router-link>
            </li>
          </ul>
        </li>
        <li>
          <p class='pageTxt'>배너관리</p>
          <ul class='depth'>
            <li>
              <router-link to='/popuplist' title='팝업관리'>팝업관리</router-link>
            </li>
            <li>
              <router-link to='/bannerlist' title='배너관리'>배너관리</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id='content'>
      <div class='inner'>
        <h3 class='pageTitle'>배너 수정</h3>
        <article>
          <!--table-->
          <div class='table horizontal-table'>
            <table>
              <caption>배너 수정 테이블</caption>
              <colgroup>
                <col style='width: 15%;'>
                <col style='width: 35%;'>
                <col style='width: 15%;'>
                <col style='width: 35%;'>
              </colgroup>
              <tbody>
              <tr>
                <th scope='row'>제목<span class='redDot'>*</span></th>
                <td colspan='3'>
                  <input type='text' title='제목 입력' v-model='title'>
                </td>
              </tr>
              <tr>
                <th scope='row'>설명</th>
                <td colspan='3'>
                  <textarea name='' id='' style='resize:none;' v-model='bannerContents'></textarea>
                </td>
              </tr>
              <tr>
                <th scope='row'>사용여부</th>
                <td>
                  <div class='radioGroup' v-if="useYn==='Y'">
                    <p class='radio'>
                      <input type='radio' id='radio-01' name='radio' v-model='useYn' value='Y' class='hidden' checked>
                      <label for='radio-01'>사용함</label>
                    </p>
                    <p class='radio'>
                      <input type='radio' id='radio-02' name='radio' class='hidden' v-model='useYn' value='N'>
                      <label for='radio-02'>사용안함</label>
                    </p>
                  </div>
                  <div class='radioGroup' v-else-if="useYn==='N'">
                    <p class='radio'>
                      <input type='radio' id='radio-01' name='radio' v-model='useYn' value='Y' class='hidden'>
                      <label for='radio-01'>사용함</label>
                    </p>
                    <p class='radio'>
                      <input type='radio' id='radio-01' name='radio' v-model='useYn' value='N' class='hidden' checked>
                      <label for='radio-02'>사용안함</label>
                    </p>
                  </div>
                </td>
                <th scope='row'>순서</th>
                <td>
                  <input type='text' title='순서 입력' v-model='bannerOrder'>
                </td>
              </tr>
              <tr>
                <th scope='row'>링크주소<span class='redDot'>*</span></th>
                <td colspan='3'>
                  <input type='text' title='링크주소 입력' class='md' v-model='linkUrl'>
                  <p class='info'>링크가 없을 경우 공백으로 작성해주세요</p>
                </td>
              </tr>
              <tr>
                <th scope='row'>이미지</th>
                <td colspan='3'>
                  <div class='fileArea'>
                    <p class='upload-name'>{{ firstName }}</p>
                    <input type='file' class='hidden' id='file' ref='files' @change='changeFile' @click='resetFile' />
                    <label for='file' class='btn gray'>파일첨부</label>
                  </div>
                  <p class='info'>첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class='btnArea'>
          <button class='btn border' @click="$router.push('bannerlist')">목록</button>
          <button class='btn gray' @click='goBackConfirm'>취소</button>
          <button class='btn blue' @click='updateBtn'>저장</button>
        </article>
      </div>
    </section>

  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      firstName: '파일명',
      bannerId: '',
      title: '',
      bannerContents: '',
      useYn: '',
      bannerOrder: '',
      bannerItem: {},
      eFiles: '',
      linkUrl: '',
    };
  },
  validations: {
    title: {
      required,
    },
    useYn: {
      required,
    },
    bannerOrder: {
      required,
    },
  },
  components: {},

  created() {
    this.bannerItem = this.$route.params.data;
    this.getBanner(this.bannerItem);
  },

  methods: {
    getBanner(bannerItem) {
      this.bannerId = bannerItem.bannerId;
      this.title = bannerItem.title;
      this.bannerContents = bannerItem.bannerContents;
      this.useYn = bannerItem.useYn;
      this.bannerOrder = bannerItem.bannerOrder;
      this.linkUrl = bannerItem.linkUrl;
      if (bannerItem.bannerImageInfo != undefined) {
        this.firstName = bannerItem.bannerImageInfo.viewNm;
      }
    },
    changeFile(e) {
      const file = e.target.files[0];
      
      if (file.size > 2000000) {
        alert('최대 20mb까지 업로드할 수 있습니다.');
        this.resetFile();
        return;
      }

      if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
        this.firstName = file.name;
        this.eFiles = file;
      }
    },

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },
    goBackConfirm() {
      this.$confirm(
        {
          message: `취소하시겠습니까?`,
          button: {
            no: '아니오',
            yes: '예',
          },
          callback: confirm => {
            if (confirm) {
              this.goBack();
            }
          },
        },
      );
    },
    goBack() {
      this.$router.go(-1);
      localStorage.clear();
    },

    async updateBtn() {

      let apiParams = new FormData();
      apiParams.append('bannerId', this.bannerId);
      apiParams.append('title', this.title);
      apiParams.append('useYn', this.useYn);
      apiParams.append('linkUrl', this.linkUrl);
      apiParams.append('bannerContents', this.bannerContents);
      apiParams.append('bannerOrder', this.bannerOrder);
      if (this.eFiles !== '') {
        apiParams.append('files', this.eFiles);
      }

      const res = await axios('post', '/api/admin/banner/updateAction.json', apiParams);
      const resMessage = res.data.message;
      alert(resMessage);
      await this.$router.push('bannerlist');
      // }
    },

  },

  computed: {},

};
</script>

